export const SENDER_RUN_STATUS_LABELS: Record<string, string> = {
	queued: 'В очереди',
	running: 'В работе',
	completed: 'Готово',
	completed_empty: 'Пустая сессия',
	completed_with_warnings: 'С предупреждениями',
	failed: 'Ошибка',
	cancelled: 'Отменён',
};
